import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../../App';
import { toast } from 'react-toastify';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleOAuthLogin = async (provider) => {
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: provider,
        options: {
          redirectTo: `${window.location.origin}/dashboard/matches`
        }
      });
      if (error) {
        toast.error(error.message);
      }
    } catch (error) {
      toast.error('Failed to login with ' + provider);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error('Please fill in all fields');
      return;
    }

    setLoading(true);
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;

      toast.success('Welcome back, warrior! 🎮');
      // Navigation will be handled by ProtectedRoute
    } catch (error) {
      toast.error(error.message || 'Failed to login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-header">
        <h1 className="game-title">
          <span className="zero">ZERO</span>
          <span className="ping">PING</span>
        </h1>
        <p className="tagline">Battle Royale Tournament Platform</p>
      </div>

      <div className="card" style={{ width: '100%', maxWidth: '450px' }}>
        <Link
          to="/"
          style={{
            background: 'transparent',
            border: 'none',
            color: 'var(--primary-color)',
            cursor: 'pointer',
            fontSize: '0.9rem',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            textDecoration: 'none'
          }}
        >
          ← Back to Home
        </Link>

        <h2 style={{
          fontSize: '2rem',
          marginBottom: '10px',
          textAlign: 'center',
          fontFamily: 'Orbitron, sans-serif',
          color: 'var(--primary-color)'
        }}>
          LOGIN
        </h2>
        <p style={{
          textAlign: 'center',
          color: 'var(--text-secondary)',
          marginBottom: '30px',
          fontSize: '0.9rem'
        }}>
          Enter the battleground
        </p>

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              placeholder="warrior@zeroping.gg"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', marginTop: '10px' }}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
            <div style={{ flex: 1, borderBottom: '1px solid var(--border-color)' }}></div>
            <span style={{ padding: '0 10px', color: 'var(--text-secondary)', fontSize: '0.8rem' }}>OR</span>
            <div style={{ flex: 1, borderBottom: '1px solid var(--border-color)' }}></div>
          </div>

          <button
            type="button"
            className="btn"
            style={{
              width: '100%',
              background: '#ffffff',
              color: '#333',
              marginBottom: '10px',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold'
            }}
            onClick={() => handleOAuthLogin('google')}
            disabled={loading}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '10px' }}>
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fillRule="evenodd" fillOpacity="1" fill="#4285f4" stroke="none"></path>
              <path d="M9.003 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.715H.957v2.332A8.997 8.997 0 0 0 9.003 18z" fillRule="evenodd" fillOpacity="1" fill="#34a853" stroke="none"></path>
              <path d="M3.964 10.712c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V4.96H.957a8.996 8.996 0 0 0 0 6.09l3.007-2.338z" fillRule="evenodd" fillOpacity="1" fill="#fbbc05" stroke="none"></path>
              <path d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9.003 0 5.488 0 2.453 2.026.957 4.96l3.007 2.338c.708-2.13 2.692-3.715 5.039-3.715z" fillRule="evenodd" fillOpacity="1" fill="#ea4335" stroke="none"></path>
            </svg>
            Continue with Google
          </button>

          <div style={{
            textAlign: 'center',
            marginTop: '20px',
            color: 'var(--text-secondary)'
          }}>
            Don't have an account?{' '}
            <Link
              to="/register"
              style={{
                color: 'var(--primary-color)',
                textDecoration: 'underline',
                fontFamily: 'Rajdhani, sans-serif'
              }}
            >
              Register here
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
